import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";

import productimage18 from "../../images/product-img-18.jpg";
import { MagnifyingGlass } from "react-loader-spinner";
import ScrollToTop from "../ScrollToTop";

// ✅ Backend base URL
axios.defaults.baseURL = "https://api.freshcart4u.com";

const ShopWishList = () => {
  const [loaderStatus, setLoaderStatus] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoaderStatus(false), 1500);
  }, []);

  /* =========================
     ADD TO CART + REMOVE
  ========================== */
  const handleAddToCart = async (product) => {
    const token = localStorage.getItem("token");

    if (!token) {
      alert("Please login first");
      return;
    }

    try {
      // 1️⃣ ADD TO CART (✅ correct payload)
      await axios.post(
        "/api/cart/add",
        {
          productId: product._id,
          quantity: 1,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // 2️⃣ REMOVE FROM WISHLIST (✅ NO userId)
      await axios.delete(`/api/wishlist/remove/${product._id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      alert("Added to cart & removed from wishlist!");
    } catch (err) {
      console.error(err);
      alert("Failed to add to cart");
    }
  };

  /* =========================
     REMOVE ONLY
  ========================== */
  const handleRemoveFromWishlist = async (productId) => {
    const token = localStorage.getItem("token");

    if (!token) {
      alert("Please login first");
      return;
    }

    try {
      await axios.delete(`/api/wishlist/remove/${productId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      alert("Removed from wishlist!");
    } catch (err) {
      console.error(err);
      alert("Failed to remove");
    }
  };

  return (
    <>
      {loaderStatus ? (
        <div className="loader-container">
          <MagnifyingGlass
            visible
            height="100"
            width="100"
            glassColor="#c0efff"
            color="#0aad0a"
          />
        </div>
      ) : (
        <>
          <ScrollToTop />

          <section className="my-14">
            <div className="container">
              <div className="row">
                <div className="offset-lg-1 col-lg-10">
                  <div className="mb-8">
                    <h1 className="mb-1">My Wishlist</h1>
                    <p>There are products in this wishlist.</p>
                  </div>

                  <div className="table-responsive">
                    <table className="table text-nowrap">
                      <thead className="table-light">
                        <tr>
                          <th></th>
                          <th></th>
                          <th>Product</th>
                          <th>Amount</th>
                          <th>Status</th>
                          <th>Actions</th>
                          <th>Remove</th>
                        </tr>
                      </thead>

                      <tbody>
                        {/* DEMO ROW */}
                        <tr>
                          <td className="align-middle">
                            <input type="checkbox" className="form-check-input" />
                          </td>

                          <td className="align-middle">
                            <Link to="#">
                              <img
                                src={productimage18}
                                className="img-fluid icon-shape icon-xxl"
                                alt="product"
                              />
                            </Link>
                          </td>

                          <td className="align-middle">
                            <h5 className="fs-6 mb-0">
                              <Link to="#" className="text-inherit">
                                Organic Banana
                              </Link>
                            </h5>
                            <small>₹98 / lb</small>
                          </td>

                          <td className="align-middle">₹35.00</td>

                          <td className="align-middle">
                            <span className="badge bg-success">In Stock</span>
                          </td>

                          <td className="align-middle">
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={() =>
                                handleAddToCart({
                                  _id: "123",
                                })
                              }
                            >
                              Add to Cart
                            </button>
                          </td>

                          <td className="align-middle text-center">
                            <button
                              className="btn btn-link text-muted"
                              onClick={() => handleRemoveFromWishlist("123")}
                            >
                              <i className="fas fa-trash-alt"></i>
                            </button>
                          </td>
                        </tr>
                        {/* END */}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default ShopWishList;
